export const API_fleet_asset = (fleetId: string): string => `/api/v1/asset?fleetId=${fleetId}`;
export const API_create_asset = (fleetId: string): string => `/api/v1/asset?fleetId=${fleetId}`;
export const API_asset = (assetId: string): string => `/api/v1/asset/${assetId}`;
export const API_asset_image = (): string => `/api/v1/asset/image`;
export const API_asset_export = (): string => `/api/v1/asset/exports/pdf`;
